import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  IconButton,
  InputLabel,
  Typography,
  Select,
  MenuItem,
} from '@material-ui/core';
import { ExpandMore, Delete } from '@material-ui/icons';
import { EquipeCargo, EquipeFuncao } from '../../pages/AddEducation/utils';
import { formStyles } from './styles';
import AccordionDeleteWarn from '../AccordionDeleteWarn';
import { EquipeMissaoObject } from '../../@types/educationTypes';

interface IProps {
  equipeMissaoDetailsObject: EquipeMissaoObject;
  deleteEquipeMissaoDetails: (index: number) => void;
  changeEquipeMissaoDetailState: (viaDetail: EquipeMissaoObject) => void;
  requiredFields: string[];
}

const EquipeMissaoForm: React.FC<IProps> = ({
  equipeMissaoDetailsObject,
  deleteEquipeMissaoDetails,
  changeEquipeMissaoDetailState,
  requiredFields,
}) => {
  const [equipeMissaoDetailsState, setEquipeMissaoDetailsState] = useState<
    EquipeMissaoObject
  >(equipeMissaoDetailsObject);
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const classes = formStyles();

  const handleChange = (key: string, value: string) => {
    setEquipeMissaoDetailsState({ ...equipeMissaoDetailsState, [key]: value });
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenWarn(!openWarn);
  };

  useEffect(() => {
    setEquipeMissaoDetailsState((prev) => {
      return { ...prev, index: equipeMissaoDetailsObject.index };
    });
  }, [equipeMissaoDetailsObject]);

  return (
    <div className={classes.accordionRow}>
      <Accordion style={{ marginRight: 10, marginBottom: 15, width: '100%' }}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>
            {`Equipe da Missão
           ${equipeMissaoDetailsState.index + 1}`}
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <div className={classes.label}>
                <InputLabel
                  htmlFor={`data.materialDetails[${equipeMissaoDetailsState.index}].Tipo do Material`}
                  className={classes.label}
                >
                  Nome
                </InputLabel>
                <input
                  name="Nome"
                  id={`data.equipeDaMissao[${equipeMissaoDetailsState.index}].nome`}
                  className={classes.input}
                  onChange={(event) => handleChange('nome', event.target.value)}
                  onBlur={() => changeEquipeMissaoDetailState(equipeMissaoDetailsState)}
                  value={equipeMissaoDetailsState.nome}
                  placeholder="Nome"
                />
              </div>
            </Grid>

            <Grid item xs={4}>
              <div className={classes.label}>
                <InputLabel
                  htmlFor={`data.equipeMissaoDetails[${equipeMissaoDetailsState.index}].funcao`}
                  className={classes.label}
                >
                  Função
                </InputLabel>
                <Select
                  variant="outlined"
                  className={classes.select}
                  value={equipeMissaoDetailsState.funcao}
                  onChange={(event) => {
                    handleChange('funcao', event.target.value as string);
                  }}
                  onBlur={() => changeEquipeMissaoDetailState(equipeMissaoDetailsState)}
                >
                  {EquipeFuncao.map((item) => (
                    <MenuItem value={item} key={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>

            <Grid item xs={4}>
              <div className={classes.label}>
                <InputLabel
                  htmlFor={`data.equipeMissaoDetails[${equipeMissaoDetailsState.index}].cargo`}
                  className={classes.label}
                >
                  Cargo
                </InputLabel>
                <Select
                  variant="outlined"
                  className={classes.select}
                  value={equipeMissaoDetailsState.cargo}
                  onChange={(event) => {
                    handleChange('cargo', event.target.value as string);
                  }}
                  onBlur={() => changeEquipeMissaoDetailState(equipeMissaoDetailsState)}
                >
                  {EquipeCargo.map((item) => (
                    <MenuItem value={item} key={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <IconButton
        onClick={handleClick}
        title={`Remover Material ${equipeMissaoDetailsState.index + 1}`}
      >
        <Delete />
      </IconButton>

      <AccordionDeleteWarn
        message={`Remover Material ${equipeMissaoDetailsState.index + 1}?`}
        open={openWarn}
        setOpen={setOpenWarn}
        index={equipeMissaoDetailsState.index}
        anchorEl={anchorEl}
        deleteItem={() => deleteEquipeMissaoDetails(equipeMissaoDetailsState.index)}
      />
    </div>
  );
};

export default EquipeMissaoForm;
